<template>
    <div>
        <!-- 桌面端表格布局 -->
        <div class="hidden md:block overflow-x-auto album-items">
            <table class="table table-pin-rows">
                <thead>
                    <tr>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70">专辑</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70">年份</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70">流派</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70">歌曲数</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70 text-center">收藏</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70">添加时间</th>
                        <th class="bg-base-200 font-semibold text-sm text-base-content/70 text-center">操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" 
                        :class="['hover:bg-base-200 cursor-pointer transition-colors duration-200 border-b border-base-200/50', index < 15 ? 'album-item-animate-in' : '']"
                        :style="index < 15 ? { 'animation-delay': `${index * 0.05}s` } : {}"
                        @click="redirctDetail(item.id)">
                        <td class="py-2">
                            <div class="flex items-center gap-3">
                                <div class="avatar">
                                    <div class="mask mask-squircle w-12 h-12 tile-img relative overflow-hidden shadow-lg">
                                        <img :src="item.image" v-if="item.image"
                                            alt="Album Cover" class="w-full h-full object-cover" />
                                        <img v-else src="/static/dist/img/album_null.jpg" 
                                             class="w-full h-full object-cover opacity-60">
                                        <div class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-30 transition-all duration-300 flex items-center justify-center play-overlay">
                                            <div class="play-icon opacity-0 hover:opacity-100 transition-opacity duration-300" @click.stop="playNow(item.id)">
                                                <svg class="fill-white w-6 h-6 hover:scale-110 transition-transform duration-200" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"></path>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex-1 min-w-0">
                                    <div class="font-semibold text-sm text-base-content truncate">{{ item.name }}</div>
                                    <div class="text-xs text-base-content/60 truncate">{{ item.artist }}</div>
                                </div>
                            </div>
                        </td>
                        <td class="text-base-content/70 text-sm">{{ item.year || '-' }}</td>
                        <td class="text-base-content/70 text-sm">{{ item.genreId || '-' }}</td>
                        <td class="text-base-content/70 text-sm text-center">{{ item.songCount || '-' }}</td>
                        <td class="text-center">
                            <button class="btn btn-ghost btn-xs btn-circle" @click.stop="addFavouriteAlbum(item)">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                     :class="['h-4', 'w-4', item.favourite ? 'fill-red-500 text-red-500' : 'fill-none']" 
                                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" 
                                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                            </button>
                        </td>
                        <td class="text-base-content/70 text-sm">{{ formatDate(item.created) }}</td>
                        <td class="text-center">
                            <div class="dropdown dropdown-left" @focusin="setRowZIndex($event, true)" @focusout="setRowZIndex($event, false)">
                                <div tabindex="0" role="button" class="btn btn-ghost btn-xs btn-circle" @click.stop>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                    </svg>
                                </div>
                                <ul tabindex="0" class="dropdown-content z-[3] menu p-2 shadow bg-base-100 rounded-box w-52">
                                    <li><a @click.stop="playNow(item.id)">立即播放</a></li>
                                    <li><a @click.stop="playNext(item.id)">下一首播放</a></li>
                                    <li><a @click.stop="playLater(item.id)">添加到队列</a></li>
                                </ul>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 移动端卡片布局 -->
        <div class="md:hidden space-y-2">
            <div v-for="(item, index) in items" :key="index" 
                 :class="['card bg-base-100 shadow-sm hover:shadow-md transition-shadow duration-200 border border-base-200/30 rounded-lg', index < 15 ? 'album-item-animate-in' : '']"
                 :style="index < 15 ? { 'animation-delay': `${index * 0.05}s` } : {}">
                <div class="card-body p-3">
                    <div class="flex items-center gap-3" @click="redirctDetail(item.id)">
                        <div class="avatar flex-shrink-0">
                            <div class="mask mask-squircle w-12 h-12 tile-img relative overflow-hidden">
                                <img :src="item.image" v-if="item.image"
                                    alt="Album Cover" class="w-full h-full object-cover" />
                                <img v-else src="/static/dist/img/album_null.jpg" 
                                     class="w-full h-full object-cover opacity-60">
                                <div class="absolute inset-0 bg-black bg-opacity-0 active:bg-opacity-30 transition-all duration-200 flex items-center justify-center">
                                    <div class="play-icon opacity-0 active:opacity-100 transition-opacity duration-200" @click.stop="playNow(item.id)">
                                        <svg class="fill-white w-5 h-5" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M512 1024A512 512 0 1 1 512 0a512 512 0 0 1 0 1024zM383.232 287.616v448l384-223.104-384-224.896z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 min-w-0">
                            <h3 class="font-semibold text-sm text-base-content truncate leading-tight">{{ item.name }}</h3>
                            <p class="text-xs text-base-content/60 truncate mt-0.5">{{ item.artist }}</p>
                            <div class="flex items-center gap-2 mt-1 text-xs text-base-content/50">
                                <span v-if="item.year" class="badge badge-ghost badge-xs px-1.5 py-0.5">{{ item.year }}</span>
                                <span v-if="item.songCount" class="text-xs">{{ item.songCount }}首</span>
                            </div>
                        </div>
                        <div class="flex items-center gap-1 flex-shrink-0">
                            <!-- 收藏按钮 -->
                            <button class="btn btn-ghost btn-xs btn-circle p-1" @click.stop="addFavouriteAlbum(item)">
                                <svg xmlns="http://www.w3.org/2000/svg" 
                                     :class="['h-4', 'w-4', item.favourite ? 'fill-red-500 text-red-500' : 'fill-none']" 
                                     viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" 
                                          d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                            </button>
                            <!-- 更多操作按钮 -->
                            <div class="dropdown dropdown-left" @focusin="setRowZIndex($event, true)" @focusout="setRowZIndex($event, false)">
                                <div tabindex="0" role="button" class="btn btn-ghost btn-xs btn-circle p-1" @click.stop>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01" />
                                    </svg>
                                </div>
                                <ul tabindex="0" class="dropdown-content z-[3] menu p-1.5 shadow bg-base-100 rounded-box w-36 text-xs">
                                    <li><a @click.stop="playNow(item.id)" class="py-1.5 px-2">立即播放</a></li>
                                    <li><a @click.stop="playNext(item.id)" class="py-1.5 px-2">下一首播放</a></li>
                                    <li><a @click.stop="playLater(item.id)" class="py-1.5 px-2">添加到队列</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 空状态 -->
        <div v-if="!items || items.length === 0" class="flex flex-col items-center justify-center py-16 text-center">
            <div class="text-6xl mb-4">🎵</div>
            <h3 class="text-xl font-semibold text-base-content mb-2">暂无专辑</h3>
            <p class="text-base-content/60">还没有找到任何专辑，请稍后再试</p>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        props: {
            items: {type: Array, required: true},
            allowHScroll: {type: Boolean, default: false}
        },
        data() {
            return {
                favourites: []
            }
        },
        methods: {
            setRowZIndex(event, active) {
                try {
                    const host = event.currentTarget.closest('tr') || event.currentTarget.closest('.card')
                    if (!host) return
                    if (active) {
                        host.classList.add('relative')
                        host.classList.add('z-50')
                    } else {
                        host.classList.remove('z-50')
                    }
                } catch (e) {
                    // ignore
                }
            },
            async playNow(id) {
                try {
                    const album = await this.$api.subsonic.getAlbumDetails(id)
                    return this.$store.dispatch('playTrackList', {
                        tracks: album.tracks
                    })
                } catch (error) {
                    console.error('播放专辑失败:', error)
                    // 可以添加错误提示
                }
            },
            async playNext(id) {
                console.log('playNext', id)
                try {
                    const album = await this.$api.subsonic.getAlbumDetails(id)
                    this.$store.commit('setNextInQueue', album.tracks)
                    this.$myMsg.notify({
                        title: '添加成功！',
                        type: 'success',
                        time: 2000,
                    })
                } catch (error) {
                    console.error('添加到下一首失败:', error)
                }
            },
            async playLater(id) {
                try {
                    const album = await this.$api.subsonic.getAlbumDetails(id)
                    this.$store.commit('addToQueue', album.tracks)
                    this.$myMsg.notify({
                        title: '添加成功！',
                        type: 'success',
                        time: 2000,
                    })
                } catch (error) {
                    console.error('添加到队列失败:', error)
                }
            },
            toggleFavourite(id) {
                return this.favouriteStore.toggle('album', id)
            },
            dragstart(id, event) {
                event.dataTransfer.setData('application/x-album-id', id)
            },
            redirctDetail(id) {
                this.$router.push({name: 'album', params: {id: id}})
            },
            addFavouriteAlbum(item) {
                const action = item.favourite ? 'removeFavourite' : 'addFavourite'
                this.$api.subsonic[action](item.id, 'album').then((res) => {
                    item.favourite = !item.favourite
                }).catch(error => {
                    console.error('收藏操作失败:', error)
                })
            },
            formatDate(date) {
                if (!date) return '-'
                return new Date(date).toLocaleDateString()
            }
        }
    }
</script>

<style scoped>
.album-items {
    min-height: 200px;
}

.tile-img {
    position: relative;
}

.play-overlay:hover .play-icon {
    opacity: 1;
}

/* 移动端触摸优化 */
@media (max-width: 768px) {
    .tile-img:active .play-icon {
        opacity: 1;
    }
    
    .card {
        transition: transform 0.2s ease;
    }
    
    .card:active {
        transform: scale(0.98);
    }
}

/* 桌面端hover效果 */
@media (min-width: 769px) {
    .tile-img:hover .play-overlay {
        background-color: rgba(0, 0, 0, 0.3);
    }
    
    .tile-img:hover .play-icon {
        opacity: 1;
    }
}

/* 滚动条样式 */
.album-items::-webkit-scrollbar {
    height: 6px;
}

.album-items::-webkit-scrollbar-track {
    background: hsl(var(--b2));
    border-radius: 3px;
}

.album-items::-webkit-scrollbar-thumb {
    background: hsl(var(--bc) / 0.2);
    border-radius: 3px;
}

.album-items::-webkit-scrollbar-thumb:hover {
    background: hsl(var(--bc) / 0.3);
}

/* 专辑列表动画 */
.album-item-animate-in {
    opacity: 0;
    animation: albumItemFadeIn 0.4s ease-out forwards;
}

@keyframes albumItemFadeIn {
    0% {
        opacity: 0;
        transform: translateX(-20px);
    }
    100% {
        opacity: 1;
        /* 结束时清空 transform，避免持久 stacking context */
        transform: none;
    }
}
</style>
